export enum ColumnNames {
  Id = 'Id',
  Name = 'Name',
  EntityKey = 'EntityKey',
  EntityProductKey = 'EntityProductKey'
}


export interface PutEntityRequest {
    id: number;
    clientId: number;
    name: string;
    currency: string;
}

export interface CreateEntityRequest {
  name: string;
}

export interface GetEntityResponse {
    id: number;
    clientId: number;
    createDate?: Date;
    name: string;
    entityKey: string;
    entityProductKey: string;
    currency: string;
}

export type EntityPageState = 'DataTable' | 'CreateEntityPage' | 'UpdateEntityPage';